/** Fields of `deferredState` saved by the block. Must match `ProjectDeferredStateInput`. */
export const PROJECT_CLARIFICATION_INPUT_FIELDS = ['deferred', 'reason', 'description', 'comment'];

/** `deferredState` of a project that has none yet: not deferred, reason "Sonstiges". */
export const DEFAULT_DEFERRED_STATE = Object.freeze({
  deferred: 'NO',
  reason: 'MISC',
  description: '',
  comment: '',
});

/**
 * `ProjectDeferredStateInput` from the block object (or the unsaved project): the four fields of
 * `deferredState`, or the defaults when the project has none.
 */
export const toProjectClarificationInput = (project) => {
  const deferredState = project.deferredState ?? DEFAULT_DEFERRED_STATE;

  return Object.fromEntries(
    PROJECT_CLARIFICATION_INPUT_FIELDS.map((field) => [field, deferredState[field] ?? null])
  );
};
